__turbopack_context__.v({
  "aspectBox": "CardRecipe-module-scss-module__cnCvga__aspectBox",
  "category": "CardRecipe-module-scss-module__cnCvga__category",
  "categoryWrapper": "CardRecipe-module-scss-module__cnCvga__categoryWrapper",
  "creator": "CardRecipe-module-scss-module__cnCvga__creator",
  "fade-in": "CardRecipe-module-scss-module__cnCvga__fade-in",
  "favoriteButtonContainer": "CardRecipe-module-scss-module__cnCvga__favoriteButtonContainer",
  "image": "CardRecipe-module-scss-module__cnCvga__image",
  "infoLockup": "CardRecipe-module-scss-module__cnCvga__infoLockup",
  "infoWrapper": "CardRecipe-module-scss-module__cnCvga__infoWrapper",
  "inner": "CardRecipe-module-scss-module__cnCvga__inner",
  "root": "CardRecipe-module-scss-module__cnCvga__root",
  "timeIcon": "CardRecipe-module-scss-module__cnCvga__timeIcon",
  "timeLabel": "CardRecipe-module-scss-module__cnCvga__timeLabel",
});
